import Nullstack from 'nullstack';
export default function IconDna2Off({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-dna-2-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
  }), "   ", Nullstack.element("path", {
    d: "M17 21.014v-1c-.004 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h9"
  }), "   ", Nullstack.element("path", {
    d: "M7 20h10"
  }), "   ", Nullstack.element("path", {
    d: "M12 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M8 16h8"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}